import { render, staticRenderFns } from "./NormalSearchNav247.vue?vue&type=template&id=4584aede&scoped=true"
import script from "./NormalSearchNav247.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav247.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4584aede",
  null
  
)

export default component.exports